import { useLayoutEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Badge } from 'rsuite';
import { DialogContent } from '@mui/material';
import { icons } from '@shared/static/icons';
import { getUserRole } from '@shared/static/roles';
import { formatBalanceUi } from '@utils/balance-helpers';
import { moreMenu, isMenuItemDisabled } from '@utils/userMenu';
import SidebarActions from './parts/SidebarActions';
import SidebarEnableTwoFa from './parts/SidebarEnableTwoFa';

function LinkElement({ item, navigateTo }) {
  const { totalBalance } = useSelector((state) => state.bankWallets);
  const { user, isUnverified, isFrozen } = useSelector((state) => state.user);
  const { t } = useTranslation();
  const isDisabled = isMenuItemDisabled(item, isUnverified, isFrozen);

  return (
    <div
      className={`moreMenu__links-item body-14r ${isDisabled ? 'disabled' : ''}`}
      onClick={() => navigateTo(item, isDisabled)}
    >
      {isDisabled ? icons.lock : icons[item.icon]}{' '}
      {item.path === '/profile' ? user.name : t(item.text)}
      {item.path === '/balances' && (
        <p
          dangerouslySetInnerHTML={{
            __html: formatBalanceUi(totalBalance, 'USD', null, true),
          }}
        />
      )}
      {item.path === '/profile' && (
        <p className="secondary-text">{t(getUserRole(user.group_role))}</p>
      )}
      {/* {item.path === '/support' && !isFrozen && (
        <Badge className="custom-badge" content={2} />
      )} */}
    </div>
  );
}

export default function MoreMenuDialog({ setTitleAction, close }) {
  const { user } = useSelector((state) => state.user);
  const navigate = useNavigate();

  useLayoutEffect(() => {
    setTitleAction(<SidebarActions />);
  }, []);

  function navigateTo(item, isDisabled) {
    if (isDisabled) return;
    close();
    navigate(item.path);
  }

  return (
    <DialogContent>
      <SidebarEnableTwoFa />
      <div className="moreMenu__links">
        {moreMenu
          .filter((item) => !item.exclude?.includes(user.group_role))
          .map((item) => (
            <LinkElement key={item.path} item={item} navigateTo={navigateTo} />
          ))}
      </div>
    </DialogContent>
  );
}
